<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Riders</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Riders
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h4>Riders</h4>
                    <div class="d-flex">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Riders_Report.csv'"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Riders_Report.xls'"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.riders.index', {}, 'csv')" class="export-link mr-2">
                            <i class="fas fa-file-csv"></i> Export to CSV
                        </a>
                        <a href="#" @click.prevent="exportTableData('admin.riders.index', {}, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel
                        </a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Name</label>
                                    <input name="search" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.name">
                                    <template v-if="errors.name">
                                        <small class="text-danger" v-for="error in errors.name">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Plate No.</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.plate_no">
                                    <template v-if="errors.plate_no">
                                        <small class="text-danger" v-for="error in errors.plate_no">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Phone Number</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.phone">
                                    <template v-if="errors.phone">
                                        <small class="text-danger" v-for="error in errors.phone">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Store</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.store">
                                        <option :value="null" :selected="filters.store==null">All</option>
                                        <option v-for="store in stores" :key="store.id"
                                                :value="store.id">
                                            {{ store.name }}
                                        </option>
                                    </select>
                                    <template v-if="errors.store">
                                        <small class="text-danger" v-for="error in errors.store">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>

                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allRiders"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'is_active'">
                                <template v-if="props.row.is_active">
                                    <span class="badge badge-glow badge-success">Active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">Inactive</span>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.riders.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";

export default {
    metaInfo: {title: 'Riders'},
    props: [
        'riders',
        'stores'
    ],
    layout: Layout,
    name: 'RiderIndex',
    components: {
        Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
    ],
    data: () => ({
        filters: {
            store: null,
        },
        errors: {},
        allRiders: [],
        exportRows: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10,
            columnFilters: {},
        },

        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'First Name', field: 'first_name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Last Name', field: 'last_name', thClass: 'text-center', tdClass: 'text-center'},
            // {label: 'Email', field: 'email', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Phone', field: 'phone', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Plate No', field: 'plate_no', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Store', field: 'store.name', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Status', field: 'is_active', thClass: 'text-center', tdClass: 'text-center'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    computed: {
        exportFields() {
            return this.buildExportFieldsFromColumns(this.columns);
        },
    },
    mounted() {
        this.allRiders = this.riders.data;
        this.totalRecords = this.riders.total;
    },

    methods: {
        async paginatedData() {
            try {
                let routeName = 'admin.riders.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters,
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allRiders = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        async deleteRider(id) {
            await this.$inertia.delete(route('admin.riders.delete', id), {
                preserveScroll: true,
                onSuccess: async () => {
                    await this.paginatedData();
                }
            })
        },

        async showAlert(riderId) {
            const details = {
                title: "Are you sure you want to delete this rider?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteRider(riderId) : "";
        },
    }
}
</script>
